// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fLDJ4WdyRb3F5dwhUfrK {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

.NVOll9LiUrK10Uu8ha82 {
  padding-left: 8px;
  color: var(--grey-color-70);
  white-space: nowrap;
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.eUOBiZaEODJCyRiH08lP {
  padding-left: 4px;
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  color: var(--neutral-3);
}

.dDiMmHy6Zi9CBja_x0PY {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--navbar-text-color);
}

.dDiMmHy6Zi9CBja_x0PY:hover {
  cursor: pointer;
}

.SHAjTgs72s2vuEjvfK8q {
  font-weight: 500;
  color: var(--grey-color-70);
  font-family: var(--font-stack-full-heavy);
  margin-right: -12px;
}

.ft9VtfCbviwP29Na_tUf {
  display: flex;
  justify-content: space-between;
}

.FKUwVTLXBZbCGJH2ZJtj {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}

.OrcO0jxoFh4vXalSAPcl {
  width: 1px;
  height: 18px;
  background-color: var(--grey-gradient-end-color-10);
  margin: 0 12px;
  align-self: center;
}

.dNXGB8xtBSgLrEbCA2AL {
  padding: 0 32px;
}

.JAnRSKpnf2EVm9UGxfUY {
  height: 88px;
  padding: 20px;
}

.zHlfXFZ5EMQHLW0jRhO9 {
  display: flex;
  margin-top: 12px;
  width: 45%;
  gap: 10px;
}

.mxiL1Aqx1EBN4CXjgSC1 {
  display: flex;
  flex-direction: column;
  font-family: var(--font-stack-full-book);
}

.vjWjTHK6GdlRGKuOBlL6 {
  display: flex;
  flex-direction: column;
}

.QhFoA7WD2MewzI62c4ZG {
  position: relative;
  top: 4px;
}

.yh230ctqEdAxFEFWqVng {
  font-weight: 800;
  font-size: 13px;
  line-height: 20px;
  color: var(--grey-color-70);
  margin: 5px;
  text-align: center;
  font-family: var(--font-stack-full-heavy);
}

.OVgjNM9FEH5k7EDqqphz {
  display: flex;
  border-radius: 20px;
  border: 1px solid var(--grey-gradient-end-color-10);
}

.J_Q0pXSpmwqPTIMabR5i {
  width: 10%;
  align-content: center;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border-right: 1px solid var(--grey-gradient-end-color-10);
}`, "",{"version":3,"sources":["webpack://./src/components/Legend/Legend.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,2BAAA;EACA,yCAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,YAAA;EACA,mDAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AACF;;AAEA;EACE,UAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,yDAAA;AACF","sourcesContent":[".actionContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 100%;\n}\n\n.actionText {\n  padding-left: 8px;\n  color: var(--grey-color-70);\n  white-space: nowrap;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.actionScore {\n  padding-left: 4px;\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 300;\n  line-height: 24px;\n  color: var(--neutral-3);\n}\n\n.statusContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: var(--navbar-text-color);\n}\n\n.statusContainer:hover {\n  cursor: pointer;\n}\n\n.statusText {\n  font-weight: 500;\n  color: var(--grey-color-70);\n  font-family: var(--font-stack-full-heavy);\n  margin-right: -12px;\n}\n\n.container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.labelContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 15px;\n}\n\n.actionDivider {\n  width: 1px;\n  height: 18px;\n  background-color: var(--grey-gradient-end-color-10);\n  margin: 0 12px;\n  align-self: center;\n}\n\n.mainWrapper {\n  padding: 0 32px;\n}\n\n.thresholdBox {\n  height: 88px;\n  padding: 20px;\n}\n\n.thresholdWrapper {\n  display: flex;\n  margin-top: 12px;\n  width: 45%;\n  gap: 10px;\n}\n\n.legendBox {\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font-stack-full-book);\n}\n\n.statusWrapper {\n  display: flex;\n  flex-direction: column;\n}\n\n.legendComponentWrapper {\n  position: relative;\n  top: 4px;\n}\n\n.scoreCardlabelText {\n  font-weight: 800;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--grey-color-70);\n  margin: 5px;\n  text-align: center;\n  font-family: var(--font-stack-full-heavy);\n}\n\n.outerContainer {\n  display: flex;\n  border-radius: 20px;\n  border: 1px solid var(--grey-gradient-end-color-10);\n}\n\n.scoreCardLabelBox {\n  width: 10%;\n  align-content: center;\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n  border-right: 1px solid var(--grey-gradient-end-color-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionContainer": `fLDJ4WdyRb3F5dwhUfrK`,
	"actionText": `NVOll9LiUrK10Uu8ha82`,
	"actionScore": `eUOBiZaEODJCyRiH08lP`,
	"statusContainer": `dDiMmHy6Zi9CBja_x0PY`,
	"statusText": `SHAjTgs72s2vuEjvfK8q`,
	"container": `ft9VtfCbviwP29Na_tUf`,
	"labelContainer": `FKUwVTLXBZbCGJH2ZJtj`,
	"actionDivider": `OrcO0jxoFh4vXalSAPcl`,
	"mainWrapper": `dNXGB8xtBSgLrEbCA2AL`,
	"thresholdBox": `JAnRSKpnf2EVm9UGxfUY`,
	"thresholdWrapper": `zHlfXFZ5EMQHLW0jRhO9`,
	"legendBox": `mxiL1Aqx1EBN4CXjgSC1`,
	"statusWrapper": `vjWjTHK6GdlRGKuOBlL6`,
	"legendComponentWrapper": `QhFoA7WD2MewzI62c4ZG`,
	"scoreCardlabelText": `yh230ctqEdAxFEFWqVng`,
	"outerContainer": `OVgjNM9FEH5k7EDqqphz`,
	"scoreCardLabelBox": `J_Q0pXSpmwqPTIMabR5i`
};
export default ___CSS_LOADER_EXPORT___;
